import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import Axios from "../axios";

function BranchSelect({ setSelectedBranch, setBranchedById }) {
  const [selectedBranch, setSelectedBranchState] = useState(null);
  const [allBranches, setAllBranches] = useState([]);


  useEffect(()=>{
    Axios.get("/api/branches").then(response=>{
      const branches = response.data;
      const branchesIdName = {}
      branches.forEach((branch)=>branchesIdName[branch._id]=branch.name)
      setBranchedById(branchesIdName)
    });
  }, [])


  useEffect(() => {
    Axios.get("/api/branches").then((resp) => setAllBranches(resp.data));
  }, []);

  const handleBranchChange = (event, newValue) => {
    if (!newValue) {
     
      setSelectedBranchState(null);
      setSelectedBranch(""); 
    } else {
      setSelectedBranchState(newValue); 
      setSelectedBranch(newValue._id); 
    }
  };

  return (
    <Autocomplete
      value={selectedBranch || {name: "All Branch"}} 
      onChange={handleBranchChange}
      options={allBranches}
      getOptionLabel={(option) => option.name} 
      renderInput={(params) => <TextField {...params} label="Search Branch" />}
      isOptionEqualToValue={(option, value) => option._id === value._id} 
      autoHighlight
      sx={{ width: 250 }}
    />
  );
}

export default BranchSelect;
